import { createContext, useContext } from "react";
import type { createApiFetch } from "./apiFetch";
import type { createBatchedActionFetch } from "./actionFetch";

export type ApiFetchFn = ReturnType<typeof createApiFetch>;
export type ActionFetchFn = ReturnType<typeof createBatchedActionFetch>;

type ApiFetchContextValue = {
	apiFetch: ApiFetchFn;
	actionFetch: ActionFetchFn;
};

const ApiFetchContext = createContext<ApiFetchContextValue | undefined>(
	undefined,
);

export const ApiFetchProvider = ApiFetchContext.Provider;

export function useApiFetchContext(): ApiFetchContextValue | undefined {
	return useContext(ApiFetchContext);
}
